import { solidstate } from ":setup/qstate";
import whitelabel from ":setup/whitelabel";

const state = solidstate.create(whitelabel);

export default {
  actions: {
    get get() {
      return state.accessor;
    },
  },
};
